// extracted by mini-css-extract-plugin
module.exports = {"root":"DeleteBtn_root__zTj6V"};